// extracted by mini-css-extract-plugin
export default {"manageRoleAndAccessWrapper":"styles_manageRoleAndAccessWrapper__fSKqA","flexedItem":"styles_flexedItem__PigmB"};